export default {
	home: 'Anasayfa',
	'items-tree': 'Öğe ağacı',
	'accounts-tree': 'Hesap ağacı',
	stores: 'Mağaza',
	'all-invoices': 'Tüm faturalar',
	'sale-invoice': 'Satış faturası',
	'sales-invoice-returned': 'Satış fatura iadesi',
	'pruchase-invoice': 'Satın alma faturası',
	'store-cashboxes': 'Kasalar',
	reports: 'Raporlar',
	statment: 'Ürün Ekstrası',
	'item-inventory': 'Ürün envanteri',
	units: 'Birimler',
	user: 'Kullanıcı',
	'choose-store': 'Mağaza Seçin',
	'account-statement': 'Hesap özeti',
	'all-journals': 'Tüm nakit yövmiye ',
	'cashbox-journal': 'Nakit yövmiye',

	'journals-items': 'Öğeler Yövmiyeler',
	'journal-item': 'Öğe Yövmiye',
	'all-journals-items': 'Tüm yövmiyeler',
	'items-journal-table': 'Öğeler yövmiye tablosu',
	users: 'Kullanıcılar',
	// 'setting-store': 'Setting store',
	'store-info': 'Mağaza bilgileri',
	'switch-store': 'Mağaza Değişim',
	'store-settings': 'Mağza ayarları',
	'are-you-sure-you-want-to-logout': 'Çıkış yapmak istediğinizden emin misiniz?',
	'daily-journal': 'Günlük yövmiye',
	'funds-journal-table': 'Yövmiye tablosu'
}